import { init, track, identify, Identify } from '@amplitude/analytics-browser';
import { AMPLITUDE_KEY } from '../settings';

export const initializeAmplitude = (userId: string) => {
  if (!AMPLITUDE_KEY) {
    return;
  }
  init(AMPLITUDE_KEY, userId);
};

export const trackEvent = (name: string, data?: Record<string, any>) => {
  if (!AMPLITUDE_KEY) {
    return;
  }
  track(name, data);
};

export const setUserForTracking = (id: string, name?: string) => {
  if (!AMPLITUDE_KEY) {
    return;
  }
  const identifyObj = new Identify();
  identifyObj.setOnce('id', id);
  identifyObj.setOnce('name', name as string);

  identify(identifyObj);
};

export const setAmplitudeUserProperty = (key: string, value: string | string[]) => {
  const identifyObj = new Identify();
  identifyObj.set(key, value);
  identify(identifyObj);
}

export function trackEventWrapper(eventName: string, fn: Function) {
  return function(this: any, ...args: any[]) {
    trackEvent(eventName);
    return fn.apply(this, args);
  };
}

export const AmplitudeEvent = {
  
};